<template>
    <label class="contact-entry-point"> Entry Point: {{ contactEntryPoint }} </label>
</template>

<script setup>
import { entryPoint } from '~/components/filters';
import {computed} from 'vue';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
});

const contactEntryPoint = computed(() => {
    return entryPoint(props.contact.entry_point);
});
</script>

<style lang="scss">
.contact-entry-point {
    font-family: var(--font-open-sans);
    font-weight: var(--weight-regular);
    font-size: 0.8125rem; // 13px
    color: var(--color-grey-600);
    margin: 16px auto 0 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}
</style>
